import { createStore } from 'vuex'
import hrModule from '@/store/modules/hr'
import appModule from '@/store/modules/app'
import wikiModule from '@/store/modules/wiki'
import bugsModule from '@/store/modules/bugs'
import tasksModule from '@/store/modules/tasks'
import booksModule from '@/store/modules/books'
import usersModule from '@/store/modules/users'
import teamsModule from '@/store/modules/teams'
import bonusModule from '@/store/modules/bonus'
import minusModule from '@/store/modules/minus'
import eventsModule from '@/store/modules/events'
import authorsModule from '@/store/modules/authors'
import reportsModule from '@/store/modules/reports'
import projectsModule from '@/store/modules/projects'
import accessesModule from '@/store/modules/accesses'
import financesModule from '@/store/modules/finances'
import documentsModule from '@/store/modules/documents'
import tasksDataModule from '@/store/modules/tasksData'
import inventoryModule from '@/store/modules/inventory'
import automationModule from '@/store/modules/automation'
import notificationModule from '@/store/modules/notification'
import authorizationModule from '@/store/modules/authorization'
import reviewQuestionsModule from '@/store/modules/reviewQuestions'
import positionsModule from '@/store/modules/positions'
import rolesModule from '@/store/modules/roles'
import currenciesModule from '@/store/modules/currencies'
import leadsModule from '@/store/modules/leads'
import workflowsModule from '@/store/modules/workflows'
import estimationsModule from '@/store/modules/estimations'
import companyModule from '@/store/modules/company'

function createPersistedState(options = {}) {
    const { key = 'vuex', paths = [], storage = localStorage } = options

    return (store) => {
        const savedState = storage.getItem(key)
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState)
                if (paths.length === 0) {
                    store.replaceState(parsedState)
                } else {
                    paths.forEach((path) => {
                        const value = getNestedValue(parsedState, path)
                        if (value !== undefined) {
                            setNestedValue(store.state, path, value)
                        }
                    })
                }
            } catch (e) {
                console.warn('Failed to restore persisted state:', e)
            }
        }

        store.subscribe((mutation, state) => {
            try {
                let stateToSave
                if (paths.length === 0) {
                    stateToSave = state
                } else {
                    stateToSave = {}
                    paths.forEach((path) => {
                        setNestedValue(stateToSave, path, getNestedValue(state, path))
                    })
                }
                storage.setItem(key, JSON.stringify(stateToSave))
            } catch (e) {
                console.warn('Failed to persist state:', e)
            }
        })
    }
}

function getNestedValue(obj, path) {
    return path.split('.').reduce((current, key) => current?.[key], obj)
}

function setNestedValue(obj, path, value) {
    const keys = path.split('.')
    const lastKey = keys.pop()
    const target = keys.reduce((current, key) => {
        if (!current[key]) current[key] = {}
        return current[key]
    }, obj)
    target[lastKey] = value
}

export default createStore({
    state: {
        sidebarVisible: '',
        sidebarUnfoldable: false,
    },
    mutations: {
        toggleSidebar(state) {
            state.sidebarVisible = !state.sidebarVisible
        },
        changeSidebarVisible(state, payload) {
            state.sidebarVisible = payload
        },
        toggleUnfoldable(state) {
            state.sidebarUnfoldable = !state.sidebarUnfoldable
        },
        updateSidebarVisible(state, payload) {
            state.sidebarVisible = payload.value
        },
    },
    getters: {
        isSidebarVisible: (state) => state.sidebarVisible,
    },
    modules: {
        authorization: authorizationModule,
        wiki: wikiModule,
        tasks: tasksModule,
        bugs: bugsModule,
        books: booksModule,
        users: usersModule,
        teams: teamsModule,
        authors: authorsModule,
        documents: documentsModule,
        projects: projectsModule,
        events: eventsModule,
        reports: reportsModule,
        bonus: bonusModule,
        minus: minusModule,
        app: appModule,
        hr: hrModule,
        accesses: accessesModule,
        reviewQuestions: reviewQuestionsModule,
        tasksData: tasksDataModule,
        notifications: notificationModule,
        finances: financesModule,
        inventory: inventoryModule,
        automation: automationModule,
        positions: positionsModule,
        roles: rolesModule,
        currencies: currenciesModule,
        leads: leadsModule,
        workflows: workflowsModule,
        estimations: estimationsModule,
        company: companyModule,
    },
    plugins: [
        createPersistedState({
            key: 'start_app',
            paths: ['app', 'hr', 'users', 'authorization', 'documents'],
            storage: {
                getItem: (key) => localStorage.getItem(key),
                setItem: (key, data) => localStorage.setItem(key, data),
                removeItem: (key) => localStorage.removeItem(key),
            },
        }),
    ],
})
